.gallery {
  display: flex;
  min-height: calc(100vh - var(--navbar-height));
}

.content {
  flex: 1;
  margin-left: var(--sidebar-width);
  padding: var(--space-xl);
}

.indexView,
.categoryView,
.docView {
  max-width: 1200px;
  margin: 0 auto;
}


.categoryGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: var(--space-lg);
  margin-top: var(--space-xl);
}

.categoryCard {
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: var(--space-xl);
  text-align: left;
  cursor: pointer;
  transition: all var(--transition-base);
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.categoryCard:hover {
  border-color: var(--accent-cyan);
  box-shadow: 0 0 20px var(--glow-cyan);
  transform: translateY(-2px);
}

.catIcon {
  font-size: var(--text-3xl);
  margin-bottom: var(--space-xs);
}

.catTitle {
  font-family: var(--font-heading);
  font-size: var(--text-xl);
  color: var(--text-primary);
}

.catDesc {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  flex: 1;
}

.catCount {
  font-family: var(--font-code);
  font-size: var(--text-xs);
  color: var(--accent-cyan);
}

.notFound {
  text-align: center;
  padding: var(--space-3xl);
  color: var(--text-muted);
}

.empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: var(--space-3xl);
  color: var(--text-muted);
  font-family: var(--font-heading);
  font-size: var(--text-sm);
  letter-spacing: 2px;
  border: 1px dashed var(--border);
  border-radius: var(--radius-md);
}

@media (max-width: 768px) {
  .content {
    margin-left: 0;
  }
}
